module.exports = __webpack_public_path__ + "img/nrs-logo@2x.1c3d06c4.png";